/* Seelenband Steinquiz (Ersatz fuer RevenueHunt). Daten der Steine kommen aus dem Abschnitt sections/seelenband-stein-quiz.liquid, Texte und Zuordnung aus assets/seelenband-quiz-data.js */
(function () {
  'use strict';

  var DATA = window.SBQ_DATA;
  if (!DATA) { return; }
  var TEXT = DATA.TEXT, WHO = DATA.WHO, PATHS = DATA.PATHS;

  var STORAGE_KEY = 'sbq_state_v1';

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) { e.className = cls; }
    if (text !== undefined && text !== null) { e.textContent = text; }
    return e;
  }

  function decode(s) {
    try { return new DOMParser().parseFromString(String(s), 'text/html').documentElement.textContent || ''; } catch (err) { return String(s); }
  }

  function track(name, params) {
    try { if (typeof window.gtag === 'function') { window.gtag('event', name, params || {}); } } catch (e1) { /* ignorieren */ }
    try { if (typeof window.fbq === 'function') { window.fbq('trackCustom', name, params || {}); } } catch (e2) { /* ignorieren */ }
  }

  function init(root) {
    var dataNode = root.querySelector('script[data-sbq-stones]');
    var stones = {};
    try { (JSON.parse(dataNode.textContent) || []).forEach(function (s) { stones[s.key] = s; }); } catch (err) { return; }
    var inner = root.querySelector('.sbq__inner');
    var state = load() || { pos: 0, path: null, answers: {}, name: '', result: null };
    var started = false;

    function sequence() {
      var seq = ['welcome', 'name', 'who'];
      if (state.path && PATHS[state.path]) {
        PATHS[state.path].forEach(function (q) { seq.push(q.id); });
        seq.push('interlude', 'result');
      }
      return seq;
    }

    function save() { try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) { /* ignorieren */ } }

    function load() {
      try {
        var s = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
        if (!s || typeof s.pos !== 'number' || (s.path && !PATHS[s.path])) { return null; }
        if (s.result) {
          var ok = s.result.every(function (k) { return stones[k]; });
          if (!ok) { return null; }
        }
        return s;
      } catch (e) { return null; }
    }

    function clearAll() { try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) { /* ignorieren */ } }

    function go(pos, noScroll) {
      state.pos = pos;
      save();
      render(noScroll);
    }

    function questionById(id) {
      var list = state.path ? PATHS[state.path] : [];
      for (var i = 0; i < list.length; i++) { if (list[i].id === id) { return list[i]; } }
      return null;
    }

    function progressBar(p) {
      var wrap = el('div', 'sbq__progress');
      var bar = el('div', 'sbq__bar');
      var fill = el('span');
      fill.style.width = p + '%';
      bar.appendChild(fill);
      wrap.appendChild(bar);
      wrap.appendChild(el('div', null, p + TEXT.done));
      return wrap;
    }

    function backButton() {
      var b = el('button', 'sbq__back', TEXT.back);
      b.type = 'button';
      b.addEventListener('click', function () { if (state.pos > 0) { go(state.pos - 1); } });
      return b;
    }

    function computeResult() {
      var votes = {};
      var list = PATHS[state.path] || [];
      list.forEach(function (q) {
        var idx = state.answers[q.id];
        var a = q.answers[idx];
        if (!a) { return; }
        a.stones.forEach(function (k) { votes[k] = (votes[k] || 0) + 1; });
      });
      var cand = Object.keys(votes).filter(function (k) {
        var s = stones[k];
        return s && s.variants.some(function (v) { return v.available; });
      });
      for (var i = cand.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = cand[i]; cand[i] = cand[j]; cand[j] = t;
      }
      cand.sort(function (a, b) { return votes[b] - votes[a]; });
      return cand.slice(0, 3);
    }

    function card(key) {
      var s = stones[key];
      var vars = s.variants.filter(function (v) { return v.available; });
      var cur = vars[0];
      var c = el('div', 'sbq__card');
      var imgWrap = el('div', 'sbq__img');
      var img = el('img');
      img.alt = s.name;
      img.loading = 'lazy';
      imgWrap.appendChild(img);
      c.appendChild(imgWrap);
      c.appendChild(el('h3', 'sbq__name', s.name));
      if (s.claim) { c.appendChild(el('p', 'sbq__claim', s.claim)); }
      var select = null;
      if (vars.length > 1) {
        select = el('select', 'sbq__select');
        vars.forEach(function (v, i) {
          var o = el('option', null, v.title);
          o.value = String(i);
          select.appendChild(o);
        });
        select.setAttribute('aria-label', TEXT.colorLabel + ' ' + s.name);
        c.appendChild(select);
      }
      var full = decode(s.description).replace(/\s+/g, ' ').trim();
      var short = full.length > 110 ? full.slice(0, 110).replace(/\s+\S*$/, '') + '…' : full;
      var desc = el('p', 'sbq__desc', short);
      c.appendChild(desc);
      if (full.length > 110) {
        var more = el('button', 'sbq__more', TEXT.more);
        more.type = 'button';
        var open = false;
        more.addEventListener('click', function () {
          open = !open;
          desc.textContent = open ? full : short;
          more.textContent = open ? TEXT.less : TEXT.more;
        });
        c.appendChild(more);
      }
      var price = el('p', 'sbq__price');
      var link = el('a', 'sbq__btn', TEXT.viewProduct);
      function paint() {
        /* Preise kommen als fertiges HTML aus dem Shop-Geldformat (Liquid money), daher innerHTML */
        price.textContent = '';
        if (cur.compare) {
          var old = el('s');
          old.innerHTML = cur.compare;
          price.appendChild(old);
        }
        var now = el('span');
        now.innerHTML = cur.price;
        price.appendChild(now);
        img.src = cur.image || s.image;
        link.href = s.url + (s.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + cur.id;
      }
      if (select) {
        select.addEventListener('change', function () { cur = vars[parseInt(select.value, 10)]; paint(); });
      }
      link.addEventListener('click', function () { track('sb_quiz_product_click', { item_id: key, variant_id: cur.id }); });
      paint();
      c.appendChild(price);
      c.appendChild(link);
      return c;
    }

    function render(noScroll) {
      var seq = sequence();
      if (state.pos >= seq.length) { state.pos = seq.length - 1; }
      var id = seq[state.pos];
      inner.textContent = '';
      var focusEl = null;

      if (id === 'welcome') {
        focusEl = el('h2', 'sbq__title', TEXT.welcomeTitle);
        inner.appendChild(focusEl);
        TEXT.welcomeText.forEach(function (t) { inner.appendChild(el('p', 'sbq__text', t)); });
        var start = el('button', 'sbq__btn', TEXT.start);
        start.type = 'button';
        start.addEventListener('click', function () {
          if (!started) { started = true; track('sb_quiz_start'); }
          go(1);
        });
        inner.appendChild(start);
      } else if (id === 'name') {
        inner.appendChild(backButton());
        focusEl = el('h2', 'sbq__title', TEXT.nameTitle);
        inner.appendChild(focusEl);
        inner.appendChild(el('p', 'sbq__text', TEXT.nameText));
        var form = el('form');
        form.style.width = '100%';
        form.style.display = 'flex';
        form.style.flexDirection = 'column';
        form.style.alignItems = 'center';
        var input = el('input', 'sbq__input');
        input.type = 'text';
        input.maxLength = 60;
        input.placeholder = TEXT.namePlaceholder;
        input.setAttribute('aria-label', TEXT.nameTitle);
        input.value = state.name || '';
        var nb = el('button', 'sbq__btn', TEXT.next);
        nb.type = 'submit';
        form.appendChild(input);
        form.appendChild(nb);
        form.addEventListener('submit', function (ev) {
          ev.preventDefault();
          state.name = input.value.trim();
          go(2);
        });
        inner.appendChild(form);
        inner.appendChild(progressBar(0));
      } else if (id === 'who') {
        inner.appendChild(backButton());
        focusEl = el('h2', 'sbq__title', WHO.title);
        inner.appendChild(focusEl);
        var ul = el('ul', 'sbq__choices');
        WHO.answers.forEach(function (a) {
          var li = el('li');
          var b = el('button', 'sbq__choice', a.label);
          b.type = 'button';
          if (state.path === a.path) { b.className += ' is-selected'; }
          b.addEventListener('click', function () {
            if (state.path !== a.path) { state.path = a.path; state.answers = {}; state.result = null; }
            go(3);
          });
          li.appendChild(b);
          ul.appendChild(li);
        });
        inner.appendChild(ul);
        inner.appendChild(progressBar(WHO.progress));
      } else if (id === 'interlude') {
        inner.appendChild(backButton());
        focusEl = el('h2', 'sbq__title', TEXT.interlude);
        inner.appendChild(focusEl);
        var rb = el('button', 'sbq__btn', TEXT.showResult);
        rb.type = 'button';
        rb.addEventListener('click', function () {
          state.result = computeResult();
          track('sb_quiz_complete', { path: state.path, results: state.result.join(',') });
          go(state.pos + 1);
        });
        inner.appendChild(rb);
      } else if (id === 'result') {
        if (!state.result) { state.result = computeResult(); }
        focusEl = el('h2', 'sbq__title', state.name ? state.name + TEXT.resultNamed : TEXT.resultAnon);
        inner.appendChild(focusEl);
        var grid = el('div', 'sbq__grid');
        state.result.forEach(function (k) { grid.appendChild(card(k)); });
        inner.appendChild(grid);
        var rs = el('button', 'sbq__restart', TEXT.restart);
        rs.type = 'button';
        rs.addEventListener('click', function () {
          clearAll();
          state = { pos: 0, path: null, answers: {}, name: '', result: null };
          started = false;
          render();
        });
        inner.appendChild(rs);
      } else {
        var q = questionById(id);
        if (!q) { go(0, true); return; }
        inner.appendChild(backButton());
        focusEl = el('h2', 'sbq__title', q.title);
        inner.appendChild(focusEl);
        var list = el('ul', 'sbq__choices');
        q.answers.forEach(function (a, i) {
          var li = el('li');
          var b = el('button', 'sbq__choice', a.label);
          b.type = 'button';
          if (state.answers[q.id] === i) { b.className += ' is-selected'; }
          b.addEventListener('click', function () {
            state.answers[q.id] = i;
            state.result = null;
            go(state.pos + 1);
          });
          li.appendChild(b);
          list.appendChild(li);
        });
        inner.appendChild(list);
        inner.appendChild(progressBar(q.progress));
      }

      if (focusEl) { focusEl.setAttribute('tabindex', '-1'); }
      if (!noScroll && state.pos > 0) {
        var r = root.getBoundingClientRect();
        if (r.top < 0 || r.top > window.innerHeight * 0.5) { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    }

    render(true);
  }

  function boot() {
    var roots = document.querySelectorAll('.sbq[data-sbq]');
    for (var i = 0; i < roots.length; i++) { init(roots[i]); }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();